module.exports = __webpack_public_path__ + "img/logo-bd-es.8e874927.png";